import React from "react"
import {
	Grid,
	Typography,
	Chip,
	Card,
	Box
} from "@material-ui/core"
import {
	AccountBalanceOutlined as BalanceIcon,
	WhatshotOutlined as WhatshotOutlinedIcon,
	EcoOutlined as EcoOutlinedIcon,
	BuildOutlined as BuildOutlinedIcon
} from "@material-ui/icons"

import { MeetingAnalysis, MeetingProfile } from "@/services/MeetingAnalyzerService"

import useMeetingAnalyzerStyles from "@/pages/Admin/MeetingAnalyzer/Detail/styles"
import useStyles from "@/pages/Admin/MeetingAnalyzer/Detail/ProfileCard/styles"
import {
	profileToDisplayText
} from "@/utils/meetingAnalyzer"

const ALL_PROFILES: MeetingProfile[] = ["aggressive", "balanced", "passive", "technical"]

const PROFILE_DESCRIPTION =
	"O perfil indica o estilo de comunicação e abordagem comercial predominante do closer durante a reunião."

type ProfileCardProps = {
	analysis: MeetingAnalysis
}

const ProfileCard: React.FC<ProfileCardProps> = (props) => {
	const { analysis } = props

	const meetingAnalyzerClasses = useMeetingAnalyzerStyles()
	const classes = useStyles()

	const identifiedProfile = analysis.output?.closerProfile?.type
	const profileSummary = analysis.output?.closerProfile?.summary

	const profileToIconComponent: Record<MeetingProfile, React.ReactElement> = {
		aggressive: <WhatshotOutlinedIcon fontSize="small" />,
		balanced: <BalanceIcon fontSize="small" />,
		passive: <EcoOutlinedIcon fontSize="small" />,
		technical: <BuildOutlinedIcon fontSize="small" />
	}

	return (
		<Card className={meetingAnalyzerClasses.card}>
			<Grid container direction="column" spacing={2}>
				<Grid item>
					<Grid container spacing={3}>
						<Grid item>
							<Box className={classes.iconContainer}>
								<BalanceIcon />
							</Box>
						</Grid>
						<Grid item xs>
							<Grid container direction="column" spacing={1}>
								<Grid item>
									<Typography className={classes.profileEyebrow}>
										PERFIL IDENTIFICADO
									</Typography>
								</Grid>
								<Grid item>
									<Typography className={classes.profileHeading}>
										{identifiedProfile ? profileToDisplayText[identifiedProfile] : "Desconhecido"}
									</Typography>
								</Grid>
								<Grid item>
									<Typography className={meetingAnalyzerClasses.cardSubtitle}>
										{PROFILE_DESCRIPTION}
									</Typography>
								</Grid>
								{profileSummary && (
									<Grid item>
										<Typography className={meetingAnalyzerClasses.cardSubtitle}>
											{profileSummary}
										</Typography>
									</Grid>
								)}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={12}>
					<Grid container className={classes.profilePillsRow}>
						{ALL_PROFILES.map(profile => {
							const isSelected = profile === identifiedProfile

							return (
								<Grid item key={profile}>
									<Chip
										className={isSelected ? classes.segmentedPillSelected : classes.segmentedPillUnselected}
										icon={profileToIconComponent[profile]}
										label={profileToDisplayText[profile]}
										size="small"
										classes={{ icon: classes.profilePillIcon }}
									/>
								</Grid>
							)
						})}
					</Grid>
				</Grid>
			</Grid>
		</Card>
	)
}

export default ProfileCard
